// extracted by mini-css-extract-plugin
export default {"wrapper":"AnDqpEkz5Tlobz6NQiLy","contentWithIcon":"kDJVWeOr4jJKlsRMhKiB","icon":"N8zGUHDl6SgmZbFevTz8"};